import React from 'react';
import axios from 'axios';
import isEmpty from 'lodash/isEmpty';
import { SitecoreImageField } from 'components/sitecore-fields';
import userService from '../../../../general/js/user/user-service';
import {
    handleMastercardRegistrationEnforce, getVerificationEndpoint, getUserAddressBooks, verifyUserInAddressBook
} from '../helpers/toch-helpers';
import { TOCH_USER_ADDRESS_BOOK_LOCALSTORAGE_NAME } from '../../../../general/js/user/constants';
import { addQueryParams, redirectTo } from '../../../../general/js/utils';
import { QueryConstants } from '../../../../general/js/utils/query-constants';

class InfluenceBlock extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hideComponent: false,
            addressBooks: null
        };

        this.handleComponentVisibility = this.handleComponentVisibility.bind(this);
    }

    componentDidMount() {
        const { hideInfluenceBlockWithCompletedSurvey, verificationEndpoint, addressBookId } = this.props.data;
        const userAddressBooks = getUserAddressBooks();
        const hideInfluenceBlockComponent = hideInfluenceBlockWithCompletedSurvey.toLowerCase() === 'true';

        if (hideInfluenceBlockComponent && !isEmpty(verificationEndpoint) && userAddressBooks === null) {
            this.handleComponentVisibility();
        }

        const userInAddressBook = verifyUserInAddressBook(userAddressBooks, addressBookId);

        if (hideInfluenceBlockComponent && userInAddressBook) {
            this.setState({ hideComponent: true });
        }
    }

    handleComponentVisibility() {
        const endpoint = getVerificationEndpoint(this.props.data);

        axios.post(endpoint).then((response) => {
            if (response.data !== null && response.data !== undefined && response.data !== '') {
                userService.setDataInLocalStorage(TOCH_USER_ADDRESS_BOOK_LOCALSTORAGE_NAME, JSON.stringify(response.data));
                this.setState({ addressBooks: response.data });
            }
        }).catch(() => {
            this.setState({ hideComponent: false });
        });
    }

    onClick = (link) => {
        const {
            mastercardRegistrationPage
        } = this.props.data;

        if (handleMastercardRegistrationEnforce(this.props.data)) {
            redirectTo(addQueryParams(mastercardRegistrationPage.url, [
                {
                    key: QueryConstants.REDIRECT_URL,
                    value: link
                }
            ]));
            return;
        }

        userService.setDataInLocalStorage(QueryConstants.REDIRECT_URL, link);
        window.location.href = link;
    }

    render() {
        const {
            componentTitle,
            backgroundImage,
            influenceSubtitle,
            influenceTitle,
            influenceUrl,
            influenceImage,
            textLink,
            hasMasterCardBranding,
            mastercardLogo,
            mastercardText,
            influenceBlockId,
            addressBookId
        } = this.props.data;
        const { hideComponent, addressBooks } = this.state;
        const isMastercard = hasMasterCardBranding.toLowerCase() === 'true';
        const isInAddressBooks = addressBooks !== null ? verifyUserInAddressBook(JSON.stringify(addressBooks), addressBookId) : null;
        const hide = isInAddressBooks !== null ? isInAddressBooks : hideComponent;

        return (
            !hide &&
            <div className='influence-block__wrap' id={influenceBlockId}>
                <div className='influence-block__bg'>
                    <SitecoreImageField img={backgroundImage} className='influence-block__bg--img' />
                </div>
                <div className='influence-block__container container'>
                    <div className={`influence-block__content ${isMastercard ? 'mastercard-branding-right' : ''}`}>
                        {
                            isMastercard &&
                            <div className='mastercard-branding-light'>
                                <SitecoreImageField img={mastercardLogo} className='mastercard-branding-light--logo' />
                                <div className='mastercard-branding-light--title'>{mastercardText}</div>
                            </div>
                        }
                        <h3 className='influence-block__heading'>{componentTitle}</h3>
                    </div>
                    <div className='influence-block__card'>
                        <div className='influence-block__card--bg'>
                            <SitecoreImageField img={influenceImage} className='influence-block__card--img' />
                        </div>
                        <div className='influence-block__card--content-wrapper'>
                            <div className='influence-block__card--tag'>
                                {influenceSubtitle}
                            </div>
                            <div className='influence-block__card--title'>
                                {influenceTitle}
                            </div>
                            <a onClick={() => this.onClick(influenceUrl)} className='influence-block__card--cta button button--primary'>{textLink}</a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default InfluenceBlock;
